module.exports = "/_next/static/media/b46b4789a9b88cc7e99ccc51fb51e905.svg";